import { all } from 'redux-saga/effects';

import infraSaga from '#/modules/infra/saga';

export default function* rootSaga() {
  yield all([
    infraSaga(),
  ]);
}
